import { createSlice } from '@reduxjs/toolkit'

import type { PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from 'store'

export type NetworkErrorPayload = {
  code: string
  errorMessage?: string
  requestTime?: string
  endpoint?: string
  method?: string
  path?: string
  requestId?: string
  responseMessage?: string
}

export type NetworkErrorDialogState = {
  show: boolean
  code: string
  errorMessage: string
  requestTime: string
  endpoint: string
  method: string
  path: string
  requestId: string
  responseMessage: string
}

const initialState: NetworkErrorDialogState = {
  show: false,
  code: '',
  errorMessage: '',
  requestTime: '',
  endpoint: '',
  method: '',
  path: '',
  requestId: '',
  responseMessage: '',
}

export const networkErrorDialogSlice = createSlice({
  name: 'networkErrorDialog',
  initialState,
  reducers: {
    open: (state, action: PayloadAction<NetworkErrorPayload>) => {
      state.show = true
      state.code = action.payload.code
      state.errorMessage = action.payload?.errorMessage ?? ''
      state.requestTime = action.payload?.requestTime ?? ''
      state.endpoint = action.payload?.endpoint ?? ''
      state.method = action.payload?.method ?? ''
      state.path = action.payload?.path ?? ''
      state.requestId = action.payload?.requestId ?? ''
      state.responseMessage = action.payload?.responseMessage ?? ''
    },
    close: state => {
      state.show = false
      state.code = ''
      state.errorMessage = ''
      state.requestTime = ''
      state.endpoint = ''
      state.method = ''
      state.path = ''
      state.requestId = ''
      state.responseMessage = ''
    },
  },
})

export const { open, close } = networkErrorDialogSlice.actions

export const selectNetworkErrorDialogStatus = (state: RootState) => ({ ...state.networkErrorDialog })

export default networkErrorDialogSlice.reducer
